import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import profileApi from "api/profile";
import { scrollIntoView } from "utils/helper";

function UseContactDetailsInformation() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});

  const [isLoading, setIsLoading] = useState(false);
  const { notifyError, notifySuccess } = useNotify();

  const onEditContactDetails = async (values) => {
    try {
      setIsLoading(true);

      const payload = { contacts: values };

      await profileApi.updateVendorContactDetails(
        userDetails?.vendorId,
        payload
      );

      userDetails.extraInformation.contactDetails = values;
      dispatch(actions.setUserDetails(userDetails));

      notifySuccess("Has been updated successfully");
      scrollIntoView("contactDetailsScrollId");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const resetOnUnmount = () => {};
  useEffect(() => {
    return () => {
      resetOnUnmount();
    };
  }, []);

  return {
    onEditContactDetails,
    isContactDetailsLoading: isLoading,
  };
}

export default UseContactDetailsInformation;

